import LinkToCustomScriptDoc from '../links/LinkToCustomScriptDoc'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'grid',
  rowGap: '16px'
}

const contentWrapperStyle: CSSProperties = {
  display: 'grid',
  rowGap: '2px'
}

// TODO - ETD 5339 Add Doc Link
const DefaultCustomScriptInfo = () =>
  <div style={wrapperStyle}>
    <div style={contentWrapperStyle}>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Default custom script
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            The default script script will be used in all test configs automatically. To use a different script script in specific test configs, select it in the test config advance settings. To stop using script script in any test configs, make sure no default custom script is set.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToCustomScriptDoc />
    </Paragraph>
  </div>

export default DefaultCustomScriptInfo
